import { NRLogger as n } from "./contact-channels45.js";
import { attempt as r } from "./contact-channels54.js";
const i = async (t) => {
  const { data: a, error: e } = await r(
    fetch(`https://global-channel-provider-service.care.vpsvc.com/v3/channels?tenant=vistaprint&locale=${t == null ? void 0 : t.toLowerCase()}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "X-Api-Key": "Dz70ypBT7D1xRxqCCcUn71qH8iZ9qRiO3Ndbx2YU"
      }
    })
  );
  if (e)
    throw n.error("Contact Channels: Get Channels Data", {
      ...e,
      locale: t
    }), e;
  if (!a.ok)
    throw n.error("Contact Channels: Get Channels Data", {
      status: a.status,
      message: "Failed to fetch Channels Data"
    }), new Error(`HTTP error! Status: ${a.status}`);
  return { contactChannels: await a.json() };
};
export {
  i as getChannelsData
};
//# sourceMappingURL=contact-channels75.js.map
